import * as React from 'react';
import styled from 'styled-components';

import { CarouselContext } from './CarouselContext';
import { color } from 'styles/utils';

const StyledProgress = styled.span`
  dispaly: block;
  height: 0.1875rem;
  position: relative;
  width: auto;

  &::after {
    background-color: ${color('teal')};
    content: '';
    height: 100%;
    position: absolute;
    transform: scaleX(var(--progress-value, 0));
    transform-origin: left center;
    width: 100%;
  }
`;

export default function CarouselProgress(props) {
  const ref = React.useRef(null);

  const context = React.useContext(CarouselContext);

  const { autoplayProgress } = context || {};

  React.useEffect(() => {
    const unsubscribe =
      autoplayProgress &&
      autoplayProgress.subscribe((n) => {
        ref.current?.style.setProperty('--progress-value', n);
      });
    return () => {
      unsubscribe?.();
    };
  }, [autoplayProgress]);

  if (!context) {
    // Handle error
    return null;
  }

  return <StyledProgress ref={ref} {...props} />;
}
